// extracted by mini-css-extract-plugin
export default {"melodyVideo":"cN-z","isFullWidth":"dN-z","landingPageVideo":"eN-z","play":"fN-z","iframeVideo":"gN-z","playHidden":"hN-z","fullwidth":"iN-z"};